import { FormikHelpers, getIn } from 'formik';

export const useCostBreakDown = ({
  name,
  label,
  disabled,
  reply,
}: {
  name: string;
  label: string;
  disabled: boolean;
  reply: boolean;
}) => {
  return {
    name: name,
    itemType: 'paper',
    label: label,
    arrayProps: { wrap: true },
    defaultValue: [
      {
        custom_input: null,
        new: true,
      },
    ],
    jItemProps: {
      paper: {
        elevation: 0,
        sx: { pt: 0, mt: 0 },
      },
    },
    array: [
      {
        name: 'cost-breakdown',
        itemType: 'typography',
        jItemProps: { variant: 'overline' },
        label: label,
      },
      {
        name: 'custom_inputs',
        itemType: 'fieldarray',
        label: '',
        gridProps: {
          sx: { paddingTop: '15px !important' },
        },
        array: [
          {
            name: 'custom_input',
            label: 'Please enter the quote type (ex: Labor, Travel, Lodge)',
            disabled: disabled,
            jItemProps: {
              type: reply ? 'number' : 'text',
              customTextField: {
                labelOnly: !reply,
                valueOnly: reply,
                customStep: reply ? 'value' : 'label',
              },
              labelFunc: (
                name: any,
                values: any,
                formik: FormikHelpers<any>
              ) => {
                getIn(values, name);
                return reply
                  ? getIn(values, name)?.label ||
                      'Please enter the quote type (ex: Labor, Travel, Lodge)'
                  : 'Please enter the quote type (ex: Labor, Travel, Lodge)';
              },
              InputProps: reply
                ? {
                    startAdornment: '$',
                  }
                : undefined,
            },
            itemType: 'custom_textfield',
          },
        ],
        disabled: disabled ? disabled : reply,
      },
      {
        precondition: (values: any) => {
          return reply;
        },
        name: 'array_sum',
        itemType: 'arraysum',
        label: 'Total Cost: $',
        jItemProps: {
          itemName: 'array_sum',
          arrayName: 'custom_inputs',
          fullwidth: false,
          sx: {
            backgroundColor: 'rgba(118, 176, 65, 0.45)',
            borderRadius: '4px',
            px: '4px',
          },
        },
        disabled: disabled,
      },
    ],
  };
};
